// probably timing problem with lit: https://github.com/lit/lit/blob/7453e365000e6a289c139cf7e175a4742296333d/packages/reactive-element/src/css-tag.ts#L10
// if lit is loaded before style sheet it cannot handle CSSStyleSheets from AdornisCSS
import 'construct-style-sheets-polyfill'; // THIS HAS TO BE THE FIRST IMPORT FOR FIREFOX TO WORK CORRECTLY

import { BaseQLClient } from '@adornis/baseql/client/baseqlClient.js';
import '@adornis/chemistry/elements/components/x-icon.css';
import '@adornis/fonts/fontSrc/lato.css';
import { initApp } from '@adornis/functional-lit/init-app.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import '@adornis/popover/x-dropdown.css';
import { authenticationGuard } from '@adornis/user-forms/authentication-guard.js';
import { functionalLogin } from '@adornis/user-forms/function-login.js';
import { subscribeCurrentUser } from '@adornis/users/client/currentUser.js';
import { dangerouslyDisableOldPermissions } from '@adornis/users/db/a-user.js';
import { html } from 'lit';
import '../api/index.js';
import { NexusTopbar } from './components/NexusTopbar.js';
import { router } from './nexus-router.js';
import './tailwind.css' with { type: 'tailwind' };

// Force light theme on load
if (typeof window !== 'undefined') {
  document.documentElement.setAttribute('data-theme', 'light');
  document.documentElement.classList.remove('dark');
}

dangerouslyDisableOldPermissions();
BaseQLClient.initDefault();
void subscribeCurrentUser();

const NexusShell = stateful(
  () => html`
    <div class="flex h-dvh min-h-0 flex-col overflow-hidden bg-base-100">
      ${NexusTopbar({ onLogoClick: () => router.goTo('dashboard') })}
      <main class="flex flex-col flex-1 min-h-0 overflow-y-auto overscroll-y-contain">${router.outlet.value}</main>
    </div>
  `,
);

void initApp(() => {
  if (router.currentRoute.value?.route.name === 'change-password') {
    return NexusShell();
  }
  return authenticationGuard(
    () => NexusShell(),
    () => html`
      <div
        class="min-h-screen flex items-center justify-center p-4 bg-linear-to-br from-base-100 via-primary/5 to-base-200"
      >
        <div class="card w-full max-w-md bg-base-100 shadow-xl border border-primary/20">
          <div class="card-body">
            <h1 class="text-2xl font-bold text-center">Nexus</h1>
            <div class="flex justify-center mt-4">${functionalLogin({})}</div>
          </div>
        </div>
      </div>
    `,
  );
});
